import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PreCheckoutStatus } from 'src/app/models/pre-checkout-status.model';
import { AlertService } from 'src/app/services/alert.service';
import { PreCheckoutService } from 'src/app/services/pre-checkout.service';
import { Motivo } from 'src/app/shared/enums/motivo.enum';
import { Utilitarios } from 'src/app/shared/utilitarios';
import { PreCheckoutQuery } from 'src/app/state/pre-checkout.query';

@Component({
  selector: 'app-pre-checkout-aprovado',
  templateUrl: './pre-checkout-aprovado.component.html',
  styleUrls: ['./pre-checkout-aprovado.component.css']
})
export class PreCheckoutAprovadoComponent implements OnInit {

  translation: any;
  success: boolean = true;
  checkout: PreCheckoutStatus = new PreCheckoutStatus();
  dataExpiracao: any = Utilitarios.addHours(new Date(), 12).toLocaleString("pt-br");

  constructor(
    private preCheckoutService: PreCheckoutService,
    private alertService: AlertService,
    private translate: TranslateService,
    private preCheckoutQuery: PreCheckoutQuery
  ) { }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
    
    this.translate.get("preCheckout").subscribe((res) => {
      this.translation = res;
    });

    this.preCheckoutQuery.cpf$.subscribe((cpf)=>{
      this.checkout.Cpf = cpf;
    });

    this.preCheckoutQuery.sm$.subscribe((sm)=>{
      this.checkout.solicitacao_monitoramento = parseInt(sm);
    });

    this.preCheckoutAprovado();
  }

  preCheckoutAprovado(){
    this.checkout.motivo = Motivo.PreCheckoutAprovado;
    this.createEvent();
  }

  createEvent()
  {
    this.preCheckoutService.createEvent(this.checkout)
    .subscribe(
      (result) => {
        if(!result){
          this.success = false;
        }
        else{
          this.success = true;
        }
      },
      (err) => {
        this.internalError(err);
      }
    );
  }

  internalError(err){
    this.alertService.alertDanger(this.translation.internalError, null);
    console.log(err)
  }
}